import { useEffect, useState, useCallback } from "react";
import { Loader2, Save, Trophy } from "lucide-react";
import api from "../lib/apiClient";
import { toast } from "sonner";

export default function AdminGamification() {
  const [d, setD] = useState(null);
  const [levels, setLevels] = useState([]);
  const [audit, setAudit] = useState([]);
  const load = useCallback(async () => {
    try {
      const r = (await api.get("/admin/gamification")).data;
      setD(r); setLevels(r.levels || []);
      setAudit((await api.get("/admin/gamification/xp-audit")).data.logs);
    } catch { toast.error("Erreur"); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const setLv = (i, k) => (e) => setLevels((s) => s.map((l, j) => j === i ? { ...l, [k]: k === "xp_required" ? Number(e.target.value) : e.target.value } : l));
  const save = async () => {
    try { await api.put("/admin/gamification/levels", { levels }); toast.success("Niveaux enregistrés"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Échec"); }
  };
  if (!d) return <div className="flex justify-center py-20"><Loader2 className="w-7 h-7 text-amber-500 animate-spin" /></div>;
  return (
    <div className="space-y-5" data-testid="admin-gamification">
      <h1 className="font-display text-3xl font-extrabold flex items-center gap-2"><Trophy className="w-7 h-7 text-amber-400" /> Gamification</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <div className="bg-[#18181E] border border-zinc-800 rounded-2xl p-4"><p className="text-xs text-zinc-500">XP distribués</p><p className="text-2xl font-extrabold">{d.xp_total}</p></div>
        <div className="bg-[#18181E] border border-zinc-800 rounded-2xl p-4"><p className="text-xs text-zinc-500">XP moyen / user</p><p className="text-2xl font-extrabold">{d.xp_avg}</p></div>
        <div className="bg-[#18181E] border border-zinc-800 rounded-2xl p-4"><p className="text-xs text-zinc-500">Utilisateurs</p><p className="text-2xl font-extrabold">{d.users}</p></div>
      </div>
      <div className="bg-[#18181E] border border-zinc-800 rounded-2xl p-5">
        <h2 className="font-display text-lg font-bold mb-3">Top XP</h2>
        {(d.top_users || []).map((u, i) => <div key={i} className="flex justify-between text-sm py-1"><span className="text-zinc-300">{u.name || u.email}</span><span className="font-mono text-amber-400">{u.xp}</span></div>)}
      </div>
      <div className="bg-[#18181E] border border-zinc-800 rounded-2xl p-5">
        <div className="flex items-center justify-between mb-3"><h2 className="font-display text-lg font-bold">Niveaux configurables</h2>
          <button onClick={save} data-testid="levels-save" className="h-9 px-4 rounded-lg gold-gradient text-black text-sm font-semibold inline-flex items-center gap-1.5"><Save className="w-4 h-4" />Enregistrer</button></div>
        <div className="space-y-2 max-h-96 overflow-auto">
          {levels.map((l, i) => (
            <div key={l.level} className="flex flex-wrap gap-2 items-center" data-testid={`level-row-${l.level}`}>
              <span className="w-10 text-sm text-zinc-500">Niv.{l.level}</span>
              <input value={l.xp_required ?? ""} onChange={setLv(i, "xp_required")} placeholder="XP requis" className="h-9 w-28 px-2 bg-zinc-900 border border-zinc-800 rounded-lg text-sm text-zinc-100" />
              <input value={l.title ?? ""} onChange={setLv(i, "title")} placeholder="Titre" className="h-9 flex-1 min-w-[140px] px-2 bg-zinc-900 border border-zinc-800 rounded-lg text-sm text-zinc-100" />
            </div>
          ))}
        </div>
      </div>
      <div className="bg-[#18181E] border border-zinc-800 rounded-2xl p-5">
        <h2 className="font-display text-lg font-bold mb-3">Historique des ajustements XP (immuable)</h2>
        {audit.length === 0 ? <p className="text-sm text-zinc-500">Aucun ajustement.</p> : audit.map((a, i) => (
          <div key={i} className="text-sm py-2 border-b border-zinc-800/60" data-testid="xp-audit-row">
            <span className="text-zinc-300">{a.admin_email}</span> → <span className="text-zinc-400">{a.user_email}</span> · <span className={a.diff >= 0 ? "text-emerald-400" : "text-red-400"}>{a.diff > 0 ? "+" : ""}{a.diff}</span> ({a.old_value}→{a.new_value}) · <span className="text-zinc-500">{a.reason}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
